import React, { useEffect } from "react";
import moulogoempresas from "../../assets/mouLogo.png";
import { Link, useNavigate } from "react-router-dom";
import { useEmpresasLanguage } from "../../context/EmpresasLanguageContext";

const NavbarEmpresas = () => {
  const navigate = useNavigate();
  const { t } = useEmpresasLanguage();
  const nav = t.chrome.navbarEmpresas;

  useEffect(() => {
    localStorage.setItem("tipo", "empresas");
  }, []);

  return (
    <nav className="fixed top-12 left-0 w-full bg-[#e9e8f4] p-4 hidden lg:flex items-center justify-between shadow-md px-5 z-40">
      <div className="flex items-center">
        <Link to="/empresas">
          <img src={moulogoempresas} alt="MEU Aliado" className="h-14 w-auto object-contain" />
        </Link>
      </div>
      <div className="flex items-center space-x-6">
        <ul className="flex space-x-10 text-purple-700 font-bold">
          <li>
            <Link to="/empresas#beneficios" className="hover:underline">
              {nav.beneficios}
            </Link>
          </li>
          <li>
            <Link to="/empresas/direccion-de-innovacion-financiera" className="hover:underline">
              {nav.cfoFraccional}
            </Link>
          </li>
          <li>
            <Link to="/empresas/gestion-de-caja" className="hover:underline">
              {nav.gestionCaja}
            </Link>
          </li>
          <li>
            <Link to="/empresas/consejo-empresarial-sumapaz" className="hover:underline" title={nav.cezTitulo}>
              {nav.cez}
            </Link>
          </li>
          <li>
            <Link to="/empresas/gestion-de-aportes" className="hover:underline">
              {nav.gestionAportes}
            </Link>
          </li>
          <li>
            <Link to="/sueldo-inteligente" className="hover:underline">
              {nav.sueldoInteligente}
            </Link>
          </li>
          <li>
            <Link to="/empresas/blog" className="hover:underline">
              {nav.blogEmpresarial}
            </Link>
          </li>
          <li>
            <Link to="/empresas/tramites-digitales" className="hover:underline">
              {nav.tramitesDigitales}
            </Link>
          </li>
        </ul>
        <button
          onClick={() => navigate("/empresas/iniciar-sesion")}
          className="bg-purple-600 text-white px-4 py-2 rounded-lg"
        >
          {nav.iniciarSesion}
        </button>
      </div>
    </nav>
  );
};

export default NavbarEmpresas;
